import { ContextSelectedOptions } from "@appretio/context-selector";
import React from "react";
import {
  chartDualContainer,
  chartDualItem
} from "../../../components/charts/Chart.css";
import { ColourChart } from "../../../components/charts/colour/ColourChart";
import { reviewDataToColourMetrics } from "../../../components/charts/colour/util/reviewDataToColourMetrics";
import { TemporalContext } from "../../../components/temporalContextSelector/data/temporalContextOptions";
import { useFetchColours } from "../hooks/useFetchColours";
import { ReviewDataResponse } from "../hooks/useFetchReviewData";

interface ColourTabProps {
  /**
   * The applied filters from context and temporal selectors.
   */
  appliedFilters: {
    contextOptions: ContextSelectedOptions;
    temporalOptions: TemporalContext;
  };
  /**
   * Whether the user has applied any filters.
   */
  hasUserApplied: boolean;
  /**
   * The selected row data from the In-Season Review table.
   */
  selectedRowData: ReviewDataResponse;
}

/**
 * Colour tab content for In-Season Review Page.
 * Shows two ColourCharts side by side for Sales and Purchases.
 */
export const ColourTab = React.memo(function ColourTab({
  appliedFilters,
  hasUserApplied,
  selectedRowData
}: ColourTabProps) {
  const { data: baseColourData, isLoading } = useFetchColours(
    appliedFilters.contextOptions,
    appliedFilters.temporalOptions,
    hasUserApplied
  );

  const colourMetrics = reviewDataToColourMetrics(selectedRowData);

  const colourChartData = selectedRowData.length
    ? colourMetrics
    : baseColourData;

  return (
    <div className={chartDualContainer}>
      <div className={chartDualItem}>
        <ColourChart
          data={colourChartData ?? []}
          title="Sales"
          valueKey="nis3_sum"
          isLoading={isLoading}
        />
      </div>
      <div className={chartDualItem}>
        <ColourChart
          data={colourChartData ?? []}
          title="Purchase"
          valueKey="time_purchase_sum"
          isLoading={isLoading}
        />
      </div>
    </div>
  );
});
